import { isArray } from "lodash";
import { FC, useMemo } from "react";
import styled from "styled-components";

import { PIC } from "@ryde/assets";
import { useTags } from "@ryde/redux";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";

const TagsCellStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "tag-cell",
})`
  width: 100%;
  color: ${rydeColors.lightBlue};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  svg {
    padding-inline-start: 2px;
    margin-inline-end: 5px;
    cursor: pointer;
    width: 19px;
    height: 19px;
  }
  .tags-text {
    width: calc(100% - 25px);
  }
`;

interface ITagCell {
  value: string;
}

export const TagsCell: FC<ITagCell> = ({ value }) => {
  const { decorateValue } = useDecorateWithMark();

  const highlightedValue = useMemo(() => {
    return decorateValue(value);
  }, [value, decorateValue]);

  return (
    <FramerTooltip content={value} rtlStrippedBottomLeftPlacement>
      <TagsCellStyled>
        {value && <PIC.TagSVG data-e2e="tag-svg" />}
        <div className="tags-text truncate-text">{highlightedValue}</div>
      </TagsCellStyled>
    </FramerTooltip>
  );
};

interface ITagCellByIds {
  value: number[];
}

export const TagsCellByIds: FC<ITagCellByIds> = ({ value }) => {
  const { tagLabels } = useTags(isArray(value) ? value : []);
  return <TagsCell value={tagLabels} />;
};
